module.exports = "pegasus/assets/circleline-pinterest.png";